import script from "./TongHopVatTuPrintModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./TongHopVatTuPrintModal.vue?vue&type=script&lang=ts&setup=true"

import "./TongHopVatTuPrintModal.vue?vue&type=style&index=0&id=66ef4cc7&lang=scss&scoped=true"

import exportComponent from "/var/www/prod/fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66ef4cc7"]])

export default __exports__